var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 127,
    viewBox: "0 0 136 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9487,
    cy: 83.6582,
    r: 2.9801,
    transform: "rotate(-41.0718 70.9487 83.6582)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.2048,
    cy: 92.0873,
    r: 2.9801,
    transform: "rotate(-41.0718 52.2048 92.0873)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.307,
    cy: 14.3292,
    r: 2.9801,
    transform: "rotate(-41.0718 113.307 14.3292)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.933,
    cy: 28.1754,
    r: 2.9801,
    transform: "rotate(-41.0718 111.933 28.1754)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.922,
    cy: 43.5304,
    r: 2.9801,
    transform: "rotate(-41.0718 107.922 43.5304)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.8073,
    cy: 59.3798,
    r: 2.9801,
    transform: "rotate(-41.0718 98.8073 59.3798)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.8359,
    cy: 73.7656,
    r: 2.9801,
    transform: "rotate(-41.0718 86.8359 73.7656)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0146 96.1224C16.822 95.3735 16.7563 93.6593 17.8881 92.8213L30.8482 83.2255C32.14 82.269 33.9752 83.1501 34.0368 84.7563L34.7333 102.928C34.7948 104.534 33.0324 105.553 31.6711 104.698L18.0146 96.1224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMobile);
export default __webpack_public_path__ + "static/media/arrowMobile.a1ead9a5c7b177504a99ac3e232a4752.svg";
export { ForwardRef as ReactComponent };